/* @flow */

import { Roles } from 'permissions/defs';
import type { RoleList } from 'permissions/defs';

export const customerUsers: RoleList = [
  Roles.ACCOUNT_ADMIN,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.USER,
  Roles.VIEW_ONLY,
];

export const internalUsers: RoleList = [
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN_REGIONAL,
  Roles.SYSTEM_ADMIN,
];

export const userProfileRegionField: RoleList = [
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
];
